function getResizedCanvas(canvas, width, height) {
  const tmpCanvas = document.createElement('canvas')
  tmpCanvas.width = width
  tmpCanvas.height = height
  const ctx = tmpCanvas.getContext('2d')
  if (ctx) {
    ctx.drawImage(
      canvas,
      0,
      0,
      canvas.width,
      canvas.height,
      0,
      0,
      width,
      height
    )
  }
  return tmpCanvas
}

function getBlobFile(blob, filename, type) {
  return new File([blob], filename, {
    type,
  })
}

export function cropImage(croppedCanvas) {
  const resizedCanvas = getResizedCanvas(
    croppedCanvas,
    croppedCanvas.width,
    croppedCanvas.height
  )
  const imageType = 'image/png'
  const imageQuality = 1
  const promise = new Promise((resolve) => {
    resizedCanvas.toBlob(
      (blob) => {
        if (blob) {
          const cropped = {
            file: getBlobFile(blob, 'cropped', blob.type),
            image: croppedCanvas.toDataURL(),
          }
          resizedCanvas.remove()
          resolve(cropped)
        }
      },
      imageType,
      imageQuality
    )
  })

  return promise
}
